module.exports = __WEBPACK_EXTERNAL_MODULE__csnext_cs_client__;